import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import apiHandler from '../handlers/ApiHandler';

// Applies data-driven <head> SEO for the current route. Meta is resolved by the
// API (`/seo/resolve?path=`): per-page overrides on top of site-wide defaults.
// If the API is unreachable, we render nothing and the static index.html
// defaults stand — SEO never breaks the page.
const SeoHead = () => {
  const location = useLocation();
  const [seo, setSeo] = useState(null);

  useEffect(() => {
    let active = true;
    const path = location.pathname || '/';
    apiHandler
      .get(`/seo/resolve?path=${encodeURIComponent(path)}`)
      .then((data) => {
        if (active && data) setSeo(data);
      })
      .catch(() => {
        if (active) setSeo(null);
      });
    return () => {
      active = false;
    };
  }, [location.pathname]);

  if (!seo) return null;

  const twitterCard = seo.ogImage ? 'summary_large_image' : 'summary';

  return (
    <Helmet>
      {seo.title && <title>{seo.title}</title>}
      {seo.description && <meta name="description" content={seo.description} />}
      {seo.keywords && <meta name="keywords" content={seo.keywords} />}
      {seo.canonical && <link rel="canonical" href={seo.canonical} />}
      {seo.noindex && <meta name="robots" content="noindex,nofollow" />}

      <meta property="og:type" content="website" />
      {seo.siteName && <meta property="og:site_name" content={seo.siteName} />}
      {seo.title && <meta property="og:title" content={seo.title} />}
      {seo.description && <meta property="og:description" content={seo.description} />}
      {seo.ogImage && <meta property="og:image" content={seo.ogImage} />}
      {seo.canonical && <meta property="og:url" content={seo.canonical} />}

      <meta name="twitter:card" content={twitterCard} />
      {seo.twitterHandle && <meta name="twitter:site" content={seo.twitterHandle} />}
      {seo.title && <meta name="twitter:title" content={seo.title} />}
      {seo.description && <meta name="twitter:description" content={seo.description} />}
      {seo.ogImage && <meta name="twitter:image" content={seo.ogImage} />}
    </Helmet>
  );
};

export default SeoHead;
